import { render, staticRenderFns } from "./CampaignPrice.vue?vue&type=template&id=7136141d&scoped=true&"
import script from "./CampaignPrice.vue?vue&type=script&lang=ts&"
export * from "./CampaignPrice.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignPrice.vue?vue&type=style&index=0&id=7136141d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7136141d",
  null
  
)

export default component.exports